import { render, staticRenderFns } from "./productComment.vue?vue&type=template&id=58247297&"
import script from "./productComment.vue?vue&type=script&lang=js&"
export * from "./productComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports